var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4266 3.52843L9.2125 0.499574C8.87063 0.177404 8.42317 0 7.95257 0H1.83333C0.822433 0 0 0.819221 0 1.82617V15.1738C0 16.1808 0.822433 17 1.83333 17H11.1667C12.1776 17 13 16.1808 13 15.1738V4.85503C13 4.35535 12.791 3.87182 12.4266 3.52843ZM11.4554 3.98438H8.96667C8.87477 3.98438 8.8 3.9099 8.8 3.81836V1.48205L11.4554 3.98438ZM11.1667 16.0039H1.83333C1.37383 16.0039 1 15.6315 1 15.1738V1.82617C1 1.36847 1.37383 0.996094 1.83333 0.996094H7.8V3.81836C7.8 4.45915 8.32337 4.98047 8.96667 4.98047H12V15.1738C12 15.6315 11.6262 16.0039 11.1667 16.0039Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 6.64062H2.7334C2.45727 6.64062 2.2334 6.86362 2.2334 7.13867C2.2334 7.41373 2.45727 7.63672 2.7334 7.63672H10.0667C10.3429 7.63672 10.5667 7.41373 10.5667 7.13867C10.5667 6.86362 10.3429 6.64062 10.0667 6.64062Z",
    fill: "#505050"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0667 9.29688H2.7334C2.45727 9.29688 2.2334 9.51987 2.2334 9.79492C2.2334 10.07 2.45727 10.293 2.7334 10.293H10.0667C10.3429 10.293 10.5667 10.07 10.5667 9.79492C10.5667 9.51987 10.3429 9.29688 10.0667 9.29688Z",
    fill: "#505050"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1574 11.9531H2.7334C2.45727 11.9531 2.2334 12.1761 2.2334 12.4512C2.2334 12.7262 2.45727 12.9492 2.7334 12.9492H5.1574C5.43353 12.9492 5.6574 12.7262 5.6574 12.4512C5.6574 12.1761 5.43353 11.9531 5.1574 11.9531Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryIcon);
export default __webpack_public_path__ + "static/media/diary-icon.aab0b22b057cb52cce8a86a45647d9aa.svg";
export { ForwardRef as ReactComponent };